"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeviewItem = void 0;
var React = require("react");
var Keyboard_1 = require("../../_Core/Keyboard");
var Styles_1 = require("./Styles");
var TreeviewItem = function (_a) {
    var Item = _a.Item, OnKeyDownEvent = _a.OnKeyDownEvent, RenderItem = _a.RenderItem, FullWidthFocusStyling = _a.FullWidthFocusStyling, SelectedItemID = _a.SelectedItemID;
    var itemForwardRef = React.createRef();
    var handleKeyboardEvent = function (e) {
        var _a;
        if (Keyboard_1.IsUpArrow(e) || Keyboard_1.IsDownArrow(e)) {
            e.stopPropagation();
            OnKeyDownEvent(e);
        }
        else if (Keyboard_1.IsEnter(e) || Keyboard_1.IsSpace(e)) {
            e.stopPropagation();
            (_a = itemForwardRef.current) === null || _a === void 0 ? void 0 : _a.FireAddClick();
        }
        else if (Keyboard_1.IsLeftArrow(e) || Keyboard_1.IsRightArrow(e)) {
            // ignore these events, or they bubble and do strange things.
            e.preventDefault();
            e.stopPropagation();
        }
    };
    var handleClick = function (e) {
        var _a;
        e.stopPropagation();
        (_a = itemForwardRef.current) === null || _a === void 0 ? void 0 : _a.FireAddClick();
    };
    return (Item && (React.createElement(Styles_1.TreeItem, { tabIndex: -1, role: "treeitem", onKeyDown: handleKeyboardEvent, onClick: handleClick, fullWidthFocusStyling: FullWidthFocusStyling, isSelected: SelectedItemID === Item.UniqueID },
        React.createElement(Styles_1.TreeItemRowCaptionFieldInfo, null, RenderItem ? RenderItem(Item, itemForwardRef) : React.createElement("div", null, Item.Caption)))));
};
exports.TreeviewItem = TreeviewItem;
